import { AxiosPromise } from 'axios';

import { BillsAddToDenyListPayload, BillsGetDenyListResponse, BillsGetIsOnDenyListResponse } from './types';
import { baseClientConstructorProps } from '../config';
import { BaseClient, BaseClientConstructorProps, SendRequestPayload } from '../generated/baseClient';

class SettlementCarrierDenyListClient extends BaseClient {
  private _namespace: string;

  constructor(props: BaseClientConstructorProps) {
    super(props);

    this._namespace = '/api/v1/settlement/carrier_blacklists';
  }

  readonly addToDenyList = (payload: BillsAddToDenyListPayload): AxiosPromise<{ status: 'success' }> => {
    const sendRequestPayload: SendRequestPayload = {
      data: payload,
      endpoint: this._namespace,
      method: 'POST',
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._sendRequest(sendRequestPayload);
  };

  readonly getDenyList = (): AxiosPromise<BillsGetDenyListResponse> => {
    const sendRequestPayload: SendRequestPayload = {
      endpoint: this._namespace,
      method: 'GET',
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._sendRequest(sendRequestPayload);
  };

  readonly getIsOnDenyList = (id: string): AxiosPromise<BillsGetIsOnDenyListResponse> => {
    const sendRequestPayload: SendRequestPayload = {
      endpoint: `${this._namespace}/${id}`,
      method: 'GET',
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._sendRequest(sendRequestPayload);
  };

  readonly removeFromDenyList = (id: string): AxiosPromise<''> => {
    const sendRequestPayload: SendRequestPayload = {
      endpoint: `${this._namespace}/${id}`,
      method: 'DELETE',
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._sendRequest(sendRequestPayload);
  };
}

export const settlementCarrierDenyListClient = new SettlementCarrierDenyListClient(baseClientConstructorProps);
